const ActionType = {
  GETTER_DATA: "VehicleAction.GETTER_DATA",
  GETTER_VIEW_STATE: "VehicleAction.GETTER_VIEW_STATE",
}

export default ActionType